// Taux d'assurance par prestation (04/10/2026) : « Consultation » est le taux des consultations générales,
// « Consultation spécialiste » (facultatif) celui des spécialistes ; il s'affiche juste après.

export function libelleTaux(libelle) {
	return libelle === 'Consultation' ? 'Consultation généraliste' : libelle
}

export function ordonnerTaux(liste, cle) {
	const rang = item => {
		const libelle = item[cle]
		if (libelle === 'Consultation') return 0
		if (libelle === 'Consultation spécialiste') return 1
		return 2
	}
	return liste.map((item, index) => ({ item, index }))
		.sort((a, b) => (rang(a.item) - rang(b.item)) || (a.index - b.index))
		.map(entree => entree.item)
}

// Taux saisi en % (« 80 », « 80,5 ») ; vide = non renseigné.
export function tauxValide(valeur) {
	if (valeur === '' || valeur === null || valeur === undefined) return true
	const nombre = Number(String(valeur).replace(',', '.'))
	return !isNaN(nombre) && nombre >= 0 && nombre <= 100
}
